export default __webpack_public_path__ + "static/breadcrumbs-distinguishable-labels-dont-dark-6186a137ce0139ab62df0ab61f5318dd.png";